/**
 * Builds the plain-text export of the notebook: the passage and note of every
 * selection when any of them carries a note, the passages alone otherwise.
 * @param {Array<{totalText: string, annotationText: ?string}>} selections - Selections in the order they are exported
 * @param {Object} localization - Strings of the reader's language
 * @param {string} localization.export - Prefix of the file name
 * @param {string} localization.notes - Suffix of the file name when the export carries notes
 * @param {string} localization.highlight - Label of each passage when the export carries notes
 * @param {string} localization.note - Label of each note
 * @param {string} title - Title of the publication
 * @returns {{text: string, fileName: string}}
 */
export function buildNotebookTextExport(selections, localization, title) {
    const hasNotes = selections.some(selection => selection.annotationText !== null);

    return hasNotes
        ? buildNotesTextExport(selections, localization, title)
        : buildHighlightsTextExport(selections, localization, title);
}

/**
 * @param {Array<{totalText: string, annotationText: ?string}>} selections
 * @param {Object} localization
 * @param {string} title
 * @returns {{text: string, fileName: string}}
 */
function buildNotesTextExport(selections, localization, title) {
    const text = selections
        .map(
            selection =>
                `${localization.highlight}: ${selection.totalText}; ${localization.note}: ${selection.annotationText}\n\n\n`
        )
        .join('');

    return { text, fileName: `${localization.export}-${title}-${localization.notes}.txt` };
}

/**
 * @param {Array<{totalText: string}>} selections
 * @param {Object} localization
 * @param {string} title
 * @returns {{text: string, fileName: string}}
 */
function buildHighlightsTextExport(selections, localization, title) {
    const text = selections.map(selection => `${selection.totalText}\n\n\n`).join('');

    return { text, fileName: `${localization.export}-${title}.txt` };
}
